import axios from "axios";

class JobPrintoutsAPI {

  jobId: string | undefined;

  setJobId(jobId: number | string) {
    this.jobId = jobId
  }

  index() {
    return axios.get(`/jobs/${this.jobId}/printouts`)
  }

  store() {
    return axios.post(`/jobs/${this.jobId}/printouts`)
  }

  download(id: number | string) {
    return axios.get(`/jobs/${this.jobId}/printouts/${id}`, {
      responseType: 'blob'
    })
  }
}

export const jobPrintoutsAPI = new JobPrintoutsAPI()
